import { render, staticRenderFns } from "./LinhaTurnosTable.vue?vue&type=template&id=24dfecab&"
import script from "./LinhaTurnosTable.vue?vue&type=script&lang=js&"
export * from "./LinhaTurnosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports